import React, { useState } from 'react';
import './ProductTabs.css';

const ProductTabs = ({ product }) => {
  const [activeTab, setActiveTab] = useState('description');

  return (
    <div className="w-full max-w-7xl mx-auto " style={{paddingTop: '60px', paddingBottom: '40px'}}>
      {/* Tab Headers */}
      <div className="tab-buttons">
        <button
          onClick={() => setActiveTab('description')}
          className={`tab-button ${activeTab === 'description' ? 'active' : ''}`}
        >
          Product Description
        </button>
        <button
          onClick={() => setActiveTab('applications')}
          className={`tab-button ${activeTab === 'applications' ? 'active' : ''}`}
        >
          Applications
        </button>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'description' && (
          <div className="description-section" style={{marginBottom: '40px'}}>
            {product.description.map((paragraph, index) => (
              <p key={index} style={{marginBottom: '20px', lineHeight: '1.8', color: '#666'}}>
                {paragraph}
              </p>
            ))}
          </div>
        )}

        {activeTab === 'applications' && (
          <div className="container">
            <div className="row">
              {product.applications.map((app) => (
                <div key={app.id} className="col-lg-6 col-md-6 col-sm-12" style={{marginBottom: '30px'}}>
                  <div className="card-hover">
                    <div className="card-image-wrapper">
                      <img
                        src={app.image}
                        alt={app.title}
                        className="card-image"
                      />
                    </div>
                    <h3 className="card-title">{app.title}</h3>
                    <p className="card-description">{app.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductTabs;